export default function secure(value) {
  if (value === undefined || value == null)
    return value;
  else if (value.length >= 4)
    return '*'.repeat(4) + value.substr(value.length - 2);
  else
    return value;
}